import script from "./UnknownError.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnknownError.vue?vue&type=script&setup=true&lang=ts"

export default script